import {NativeModules, Platform} from 'react-native';

const {ForegroundService} = NativeModules;

export function startCheckoutForegroundService() {
  if (Platform.OS === 'android' && ForegroundService) {
    ForegroundService.start();
  }
}

export function stopCheckoutForegroundService() {
  if (Platform.OS === 'android' && ForegroundService) {
    ForegroundService.stop();
  }
}
